export const points = [] as const
